'use strict'

define ['./quickformsTable.scss', './removeModal.css'], () ->
  ($state, $rootScope, ApplicationTemplate, RENTAPPLICATION_API_URL, $uibModal, $cacheFactory, $timeout) ->
    restrict: "E"
    template: require("./quickformsTable.jade")
    link: (scope, element, attrs) ->
      scope.search_term = ""
      
      scope.go_to_edit = (row) ->
        $state.go("root.forms.quick_form", { applicationTemplateSlug: row.slug })
      
      scope.update_show_report = () ->
        scope.rowCollection.map((apptemplate) ->
          if _.find(apptemplate.landlord.report_source_profiles, {'short_label': 'Income'})
            apptemplate.landlord.show_employment_report = true
          
          if _.find(apptemplate.landlord.report_source_profiles, {'short_label': 'Current Landlord'})
            apptemplate.landlord.show_current_landlord_report = true

          if _.find(apptemplate.landlord.report_source_profiles, {'short_label': 'Previous Landlord'})
            apptemplate.landlord.show_previous_landlord_report = true             
        )
      scope.update_show_report()

      scope.search = () ->
        scope.is_loading = true
        ApplicationTemplate.query(
          search: scope.search_term.trim()
          limit: 25
        ).$promise
        .then (apptemplates) ->
          scope.rowCollection = apptemplates.objects
          scope.is_loading = false

      scope.open_delete_modal = (id) ->
        scope.current_id = id

        $uibModal.open
          scope: scope
          template: require("./removeModal.jade")
          controller: require("./removeModal.coffee")
          windowClass: 'apptemplate-delete'
        .result.then () ->
          scope.current_id = null

      scope.refresh_list = () ->
        $cacheFactory.get("$http").removeAll()
        ApplicationTemplate.query({limit: 25}).$promise
          .then (apptemplates) ->
            scope.rowCollection = apptemplates.objects

      $rootScope.$on 'forms-changed', (event, args) ->
        scope.refresh_list()

      $rootScope.$on 'paginate', (event, data) ->
        scope.is_loading = true
        ApplicationTemplate.query
          limit: 25
          offset: data.offset
          search: scope.search_term.trim()
        .$promise.then (apptemplates) ->
          scope.rowCollection = apptemplates.objects
          scope.is_loading = false
          scope.update_show_report()



// WEBPACK FOOTER //
// ./directives/quickformsTable/quickformsTable.coffee